import React, { Fragment } from 'react';
import './chapter.css'
const Chapter8_6 = () => (
  <Fragment>
    <div className='body-md'>
      <h2>Conclusions</h2>
      <p>
        Expressions in AVAP are a fundamental part of programming, allowing for a wide variety of data operations and manipulations.
        By understanding the different types of expressions and operators, as well as working with data structures such as lists, 
        developers can write clear and effective code that meets the program's requirements.
      </p>
    </div>
  </Fragment>
);

export default Chapter8_6;
